export default __webpack_public_path__ + "static/media/accelerate-inverse-2.be25b684.webp";